import { z } from 'zod';

export const CalculateMaximumMortgageSchema = z.object({
  income: z
    .number({ message: 'Vul je inkomen in' })
    .max(10000000, 'Inkomen lijkt onrealistisch hoog'),
  
  age: z
    .number({ message: 'Vul je leeftijd in' })
    .int('Leeftijd moet een heel getal zijn')
    .min(18, 'Je moet minimaal 18 jaar oud zijn')
    .max(100, 'Leeftijd moet 100 jaar of jonger zijn'),
});

export type CalculateMaximumMortgageFormValues = z.infer<typeof CalculateMaximumMortgageSchema>;